import { Send, Trash2 } from 'lucide-react';
import { IconButton, cn } from '@cyphex/ui';
import { formatDuration } from '../../lib/time';

interface VoiceRecorderBarProps {
  elapsedMs: number;
  level: number;
  onCancel: () => void;
  onSend: () => void;
}

const BAR_COUNT = 28;

/** Recording state of the composer — live meter, elapsed clock, send/discard. */
export function VoiceRecorderBar({ elapsedMs, level, onCancel, onSend }: VoiceRecorderBarProps) {
  return (
    <div className="flex items-center gap-3 px-3 py-2" role="status" aria-live="polite">
      <IconButton icon={Trash2} label="Discard recording" size="lg" variant="ghost" onClick={onCancel} />

      <span className="flex items-center gap-1.5">
        <span className="h-2 w-2 animate-pulse-ring rounded-pill bg-destructive" aria-hidden />
        <span className="text-md font-medium tabular text-foreground">{formatDuration(elapsedMs)}</span>
      </span>

      <div className="flex h-8 flex-1 items-center gap-[2px]" aria-hidden>
        {Array.from({ length: BAR_COUNT }, (_unused, index) => {
          const distance = Math.abs(index - BAR_COUNT / 2) / (BAR_COUNT / 2);
          const height = Math.max(10, level * (1 - distance * 0.7));
          return (
            <span
              key={index}
              style={{ height: `${height}%` }}
              className={cn('w-full min-w-[2px] rounded-pill bg-primary/70 transition-[height] duration-fast')}
            />
          );
        })}
      </div>

      <IconButton icon={Send} label="Send voice message" size="lg" variant="primary" onClick={onSend} />
    </div>
  );
}
